import { getStoredSelectedExperiments } from '@/reducers/ui/projectsUiReducer';
import {
  DashboardView,
  DashboardViewUpdatePayload
} from '@experiment-management-shared/types';
import { isEmpty } from 'lodash';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

type UseSyncExperimentsWithViewOpts = {
  dashboardView: DashboardView | null;
  updateDashboardView: (data: DashboardViewUpdatePayload) => void;
};
const useSyncExperimentsWithView = ({
  dashboardView,
  updateDashboardView
}: UseSyncExperimentsWithViewOpts) => {
  const hasSynced = useRef(false);

  const storedSelectedExperiments = useSelector(getStoredSelectedExperiments);
  useEffect(() => {
    if (
      !dashboardView ||
      isEmpty(storedSelectedExperiments) ||
      hasSynced.current
    ) {
      return;
    }

    updateDashboardView({
      table: { selection: storedSelectedExperiments }
    });

    hasSynced.current = true;
  }, [storedSelectedExperiments, updateDashboardView, dashboardView]);
};

export default useSyncExperimentsWithView;
